import BinIcon from '../icon/IconWrapped';
import React from 'react';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext';
import { SeeAllButtonStyled } from './styled/SeeAllButtonStyled';
import classNames from 'classnames';

interface ISeeAllButtonProps {
    className?: string;
    onClick: () => void;
}

function SeeAllButton(props: ISeeAllButtonProps) {
    const { className, onClick } = props;
    const { getLangPath } = useLangContext();

    return <SeeAllButtonStyled className={classNames('see-all', className)} onClick={onClick}>
        <span>{getLangPath('common.see_all')}</span>
        <BinIcon name={'IcForward'} size={16}/>
    </SeeAllButtonStyled>;
}

export default SeeAllButton;
